import React, { useState } from 'react';
import { Loader } from 'react-bootstrap-typeahead';
import CustomContainer from '../../../components/CustomContainer';
import CardTable from '../../../components/table/CardTable';
import columns from './VerificationTemplateTableConfig';
import { useTranslation } from 'react-i18next';
import { hasAdmin } from '../../../helpers/jwt';
import AdminVerificationTemplateTableConfig from './AdminVerificationTemplateTableConfig';

const VerificationPage = (props) => {
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Loader loader={loader} />
      <CustomContainer
        title={t('menu.verificationTemplates')}
        className={'px-4'}
      >
        <CardTable
          tittle={t('verificationTemplate.listTemplates')}
          source={'toolSetTemplate'}
          columns={
            hasAdmin() ? AdminVerificationTemplateTableConfig(t) : columns(t)
          }
          width={12}
          setLoader={setLoader}
          striped={false}
          shadow={true}
        />
      </CustomContainer>
    </>
  );
};

export default VerificationPage;
